import type { RouteProps } from 'react-router';
import { Redirect, Route } from 'react-router';

import { useAppSelector } from '../store';

export const AuthRoute = ({ children, ...rest }: RouteProps) => {
  const hasToken = useAppSelector((state) => state.advocateAuthSlice.hasToken);

  if (!hasToken) {
    return <Redirect to="/advocate-login" />;
  }

  return <Route {...rest}>{children}</Route>;
};
